import { Button, Checkbox, Divider, Row, Space } from 'antd';
import { useCallback, useContext, useMemo } from 'react';

import { FEMALE_ID, MALE_ID, UNKNOWN_GENDER_ID } from '@app/constants';
import { useWindowSize } from '@app/hooks';
import {
  CHF_CLIENTS_FILTER,
  CHF_GENDER,
} from '@app/pages/Clients/ClientsList/constants/filterKeysAndIds';
import { ClientFiltersContext } from '@app/providers';

import { hideFilterBlock } from '@pages/Clients/ClientsList/utils';

import type { CheckboxChangeEvent } from 'antd/es/checkbox';

export const ClientsGender = ({
  includedFiltersIndex,
}: {
  includedFiltersIndex: number;
}) => {
  const {
    filters,
    handleDisabling,
    setUpServerDataChunk,
    onChangeFiltersHandler,
  } = useContext(ClientFiltersContext);
  const { innerWidth } = useWindowSize();

  const memoizedGender = useMemo(
    () => filters.ClientsFilter?.[includedFiltersIndex]?.Values?.[0]?.Gender,
    [filters, includedFiltersIndex]
  );

  const handleGenderChange = useCallback(
    (event: CheckboxChangeEvent) => {
      const value =
        event.target?.value === UNKNOWN_GENDER_ID ? null : event.target?.value;
      const currentChecked = event.target?.checked;
      const allChecked = memoizedGender;
      let result = null;

      if (currentChecked) {
        result = [...(allChecked || []), value];
      } else {
        const plannedResult = allChecked?.filter((_value) => _value !== value);

        if ((plannedResult || []).length === 0) {
          result = null;
        } else {
          result = allChecked?.filter((_value) => _value !== value) || null;
        }
      }
      onChangeFiltersHandler(
        'ClientsFilter',
        includedFiltersIndex,
        'Gender',
        result
      );
    },
    [includedFiltersIndex, onChangeFiltersHandler, memoizedGender]
  );

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Space direction="vertical">
        <Checkbox
          value={FEMALE_ID}
          checked={Boolean(memoizedGender?.find((item) => item === FEMALE_ID))}
          onChange={handleGenderChange}
        >
          Женский
        </Checkbox>
        <Checkbox
          value={MALE_ID}
          checked={Boolean(memoizedGender?.find((item) => item === MALE_ID))}
          onChange={handleGenderChange}
        >
          Мужской
        </Checkbox>
        <Checkbox
          value={UNKNOWN_GENDER_ID}
          checked={
            Boolean(memoizedGender?.[0] === null) ||
            Boolean(memoizedGender?.[1] === null) ||
            Boolean(memoizedGender?.[2] === null)
          }
          onChange={handleGenderChange}
        >
          Неизвестно
        </Checkbox>

        <Divider style={{ marginTop: '0px', marginBottom: '4px' }} />
        <Row justify="end">
          <Button
            type="primary"
            size="small"
            disabled={handleDisabling(
              CHF_CLIENTS_FILTER,
              CHF_GENDER,
              false,
              '',
              includedFiltersIndex
            )}
            onClick={() => {
              setUpServerDataChunk(
                CHF_CLIENTS_FILTER,
                CHF_GENDER,
                false,
                '',
                includedFiltersIndex
              );

              hideFilterBlock(
                '.clients-gender-label',
                innerWidth,
                includedFiltersIndex
              );
            }}
          >
            Выбрать
          </Button>
        </Row>
      </Space>
    </div>
  );
};
